export const ISSUED_ITEMS_SAVED_KEY = 'inventory.issuedItems'
export const ISSUED_ITEMS_UPLOAD_RESULTS_KEY = 'inventory.issuedItems.uploadResults'
